import { gql } from '@apollo/client'

export const NONPROFIT_ORG_PROFILE = gql`
  query GetNonprofitOrgProfile($nonprofitOrgId: Int!) {
    nonprofitOrgProfile(nonprofitOrgId: $nonprofitOrgId) {
      id
      nonprofitOrgId
      candidData
      websiteData
      instagramData
      twitterData
      confirmedOrgSummary
      confirmedOrgSummaryUpdatedAt
      confirmedAreasOfImpact
      suggestedOrgSummary
      suggestedAreasOfImpact
    }
  }
`
